<template>
  <div>
    <a
      v-if="canManage && !filterOnboardingIssues && countOnboardingIssues !== null && countOnboardingIssues > 0"
      class="d-flex justify-content-between align-items-center alert alert-danger text-decoration-none text-danger"
      href="javascript:;"
      @click.prevent="filterOnboardingIssues = true"
    >
      <span>
        <i class="fa fa-exclamation-triangle mr-1 d-none d-md-inline-block"></i>
        There are {{ countOnboardingIssues }} onboarding issues in {{ office.display_name }}.
      </span>
      <span class="btn btn-sm btn-danger ml-2 text-nowrap">
        Show Me
        <i class="fa fa-rocket ml-1"></i>
      </span>
    </a>

    <b-alert
      v-if="canManage && countOnboardingIssues === 0"
      variant="success"
      show
      dismissible
    >
      <i class="fa fa-check mr-1"></i>
      There are no onboarding issues in {{ office.display_name }}!
    </b-alert>

    <div class="card card-office soft-shadow mb-3">
      <div class="card-body">
        <div class="media align-items-top">
          <div class="media-left d-none d-lg-inline-block">
            <span class="profile-img small mr-3" :style="`background-image: url(${office.image});`"></span>
          </div>
          <div class="media-body">
            <h3 class="card-title h5 font-weight-bold d-none d-lg-block">
              {{ office.display_name }}
            </h3>
            <div class="row">
              <div class="col-md-6">
                <div
                  v-if="office.name !== office.display_name"
                  class="font-weight-bold"
                >
                  {{ office.name }}
                </div>
                <address>
                  {{ office.address }}<br>
                  {{ office.city }}, {{ office.state }}
                </address>
                <div
                  class="small text-muted mb-3"
                >
                  MLS: <span class="text-uppercase">{{ office.mls_connection }}</span>
                  #{{ office.mls_id }}
                </div>
                <div class="">
                  {{ office.phone_formatted }}
                </div>
              </div>
              <div
                class="mt-3 mt-md-0 col-md-6"
              >
                <hr class="d-lg-none">
                <p
                  v-if="office.description"
                  class="small"
                  v-html="office.description"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="rosterData === null"
      class="text-muted"
    >
      <i
        v-if="loadingRoster"
        class="fa fa-fw fa-circle-o-notch fa-spin mr-1"
      ></i>
      Loading {{ office.display_name }} Rosters...
    </div>

    <a
      v-if="rosterData !== null && canManage && filterOnboardingIssues"
      class="d-flex justify-content-between align-items-center alert alert-danger text-decoration-none text-danger"
      href="javascript:;"
      @click.prevent="filterOnboardingIssues = false"
    >
      <span>
        <i class="fa fa-exclamation-triangle mr-1 d-none d-md-inline-block"></i>
        Showing only agents with onboarding issues
      </span>
      <span class="btn btn-sm btn-danger ml-2 text-nowrap">
        Remove Filter
        <i class="fa fa-close ml-1"></i>
      </span>
    </a>

    <div
      v-if="roster !== null && roster !== false"
    >
      <b-tabs pills fill content-class="mt-3">
        <b-tab :title="`Agents (${roster.agent.length})`">
          <people
            :people="roster.agent"
            :can-manage="canManage"
          ></people>
        </b-tab>
        <b-tab :title="`Teams (${roster.team.length})`">
          <teams
            :teams="roster.team"
            :can-manage="canManage"
          ></teams>
        </b-tab>
        <b-tab :title="`Staff (${roster.staff.length})`">
          <people
            :people="roster.staff"
            :can-manage="canManage"
          ></people>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getOfficeRoster } from '@/api'
import People from '@/components/roster/People'
import Teams from '@/components/roster/Teams'
import { filter, merge } from 'lodash'

export default {
  components: {
    People,
    Teams
  },
  props: {
    office: {
      type: Object,
      required: true
    },
    canManage: {
      type: Boolean,
      default: false
    },
    showOnboardingIssues: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      loadingRoster: false,
      rosterData: null,
      filterOnboardingIssues: this.showOnboardingIssues,
    }
  },
  computed: {
    roster () {
      if (this.rosterData === null) {
        return null
      }

      return {
        managing_broker: this.rosterData.managing_broker,
        team: this.rosterData.team,
        staff: this.rosterData.staff,
        agent: this.filterOnboardingIssues ?
          filter(this.rosterData.agent, roster => roster.onboardingProgress < 100)
          : this.rosterData.agent
      }
    },
    countOnboardingIssues () {
      if (this.rosterData != null) {
        return filter(this.rosterData.agent, roster => roster.onboardingProgress < 100).length
      } else {
        return null
      }
    }
  },
  mounted () {
    this.getRoster()
  },
  methods: {
    async getRoster(flush) {
      this.loadingRoster = true
      let { data } = await getOfficeRoster(this.office.id, flush)
      this.rosterData = data.roster
      this.loadingRoster = false
    },
  }
}
</script>